<div class="content-top clearfix">
  <h1 class="al-title" translate [ngClass]="{'lowercase' : activePageTitle === 'nurture.retail'}">{{ activePageTitle }}</h1>
</div>
